/**
 * Branding configurable par variables d'environnement (Option C — socle multi-cabinet).
 *
 * Aucun nom de cabinet codé en dur : la version test utilise les valeurs par défaut
 * (« Impartiale Avocat »), et chaque cabinet client (ex. CLS AVOCAT) ne fait que
 * surcharger ces variables côté projet Vercel — zéro fork de code.
 *
 *   REACT_APP_BRAND_NAME     : nom produit affiché          (def. « Impartiale Avocat »)
 *   REACT_APP_CABINET_NAME   : raison sociale du cabinet     (def. vide)
 *   REACT_APP_CABINET_OWNER  : titulaire (« Maître X »)      (def. vide)
 *   REACT_APP_LEGAL_ENTITY   : entité légale éditrice        (def. « Coach Digital Paris »)
 *   REACT_APP_ENV            : « test » => badge version test (def. vide)
 */
const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'Impartiale Avocat';
const CABINET_NAME = process.env.REACT_APP_CABINET_NAME || '';
const CABINET_OWNER = process.env.REACT_APP_CABINET_OWNER || '';
const LEGAL_ENTITY = process.env.REACT_APP_LEGAL_ENTITY || 'Coach Digital Paris';

export const BRAND = {
  name: BRAND_NAME,
  cabinetName: CABINET_NAME,
  cabinetOwner: CABINET_OWNER,
  legalEntity: LEGAL_ENTITY,
  // Libellé composé : « CLS AVOCAT — Maître Clarisse SURIN » si titulaire défini, sinon le nom produit seul.
  displayName: CABINET_OWNER ? `${BRAND_NAME} — ${CABINET_OWNER}` : BRAND_NAME,
  isTest: process.env.REACT_APP_ENV === 'test',
};

export default BRAND;
